<div class="dialog-container">
  <div class="icon-clock">
    <!-- Insertamos el SVG inline -->
    <svg xmlns="http://www.w3.org/2000/svg" height="48" width="48" viewBox="0 0 24 24" fill="currentColor"
      aria-hidden="true">
      <path
        d="M12 20c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm0-18c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10z" />
      <path d="M12.5 7h-1v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </svg>
  </div>

  <h2 class="dialog-title">{{ data.title }}</h2>

  <p class="dialog-message">{{ data.message }}</p>

  <div class="countdown" *ngIf="remainingTime >= 0">
    ⏳ Tiempo restante: {{ remainingTime }} seg
  </div>

  <div class="dialog-actions">
    <button mat-flat-button color="primary" (click)="confirm()">
      {{ data.confirmText || 'Aceptar' }}
    </button>
    <button mat-button color="warn" (click)="cancel()">
      {{ data.cancelText || 'Cancelar' }}
    </button>
  </div>
</div>